export const rules = {
    device_type_name: [
        { required: true, message: 'Пожалуйста, введите название ', trigger: 'change' },
    ],
};
